module.exports = __webpack_public_path__ + "media/jinfucloud_introduce.247bbe04.mp4";